import { Node } from "@tiptap/core";

const PLACEHOLDER_PREFIX = "![图片占位：";

export const ImagePlaceholder = Node.create({
  name: "imagePlaceholder",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      title: { default: "" },
      placement: { default: "" },
      description: { default: "" }
    };
  },

  parseHTML() {
    return [{
      tag: "figure[data-zf-image-placeholder]",
      getAttrs: (element) => ({
        title: element.getAttribute("data-title") || "",
        placement: element.getAttribute("data-placement") || "",
        description: element.getAttribute("data-description") || ""
      })
    }];
  },

  renderHTML({ node }) {
    const { title = "", placement = "", description = "" } = node.attrs;
    const meta = description ? `${placement}：${description}` : placement;
    return [
      "figure",
      {
        class: "zf-image-placeholder",
        "data-zf-image-placeholder": "",
        "data-title": title,
        "data-placement": placement,
        "data-description": description
      },
      [
        "div",
        { class: "zf-image-placeholder__frame" },
        ["span", { class: "zf-image-placeholder__badge" }, "图片占位"],
        ["strong", { class: "zf-image-placeholder__title" }, title],
        ["span", { class: "zf-image-placeholder__meta" }, meta]
      ]
    ];
  },

  markdownTokenizer: {
    name: "imagePlaceholder",
    level: "block",
    start: (source) => source.indexOf(PLACEHOLDER_PREFIX),
    tokenize(source) {
      const parsed = parsePlaceholderMarkdown(source);
      if (!parsed) return undefined;
      return {
        type: "imagePlaceholder",
        ...parsed
      };
    }
  },

  parseMarkdown(token) {
    return {
      type: "imagePlaceholder",
      attrs: {
        title: token.title || "",
        placement: token.placement || "",
        description: token.description || ""
      }
    };
  },

  renderMarkdown(node) {
    const { title = "", placement = "", description = "" } = node.attrs || {};
    return `${PLACEHOLDER_PREFIX}${escapeMarkdownField(title)}]() ${escapeMarkdownField(placement)}：${escapeMarkdownField(description)}`;
  }
});

function parsePlaceholderMarkdown(source) {
  if (!source.startsWith(PLACEHOLDER_PREFIX)) return null;
  const titleStart = PLACEHOLDER_PREFIX.length;
  const titleEnd = findUnescapedDelimiter(source, titleStart, "]()");
  if (titleEnd < 0) return null;

  let placementStart = titleEnd + 3;
  if (!/[ \t]/.test(source[placementStart] || "")) return null;
  while (/[ \t]/.test(source[placementStart] || "")) placementStart += 1;
  const placementEnd = findUnescapedDelimiter(source, placementStart, "：");
  if (placementEnd < 0) return null;

  const descriptionStart = placementEnd + 1;
  let lineEnd = descriptionStart;
  while (lineEnd < source.length && source[lineEnd] !== "\n" && source[lineEnd] !== "\r") lineEnd += 1;
  let rawEnd = lineEnd;
  if (source[rawEnd] === "\r") rawEnd += 1;
  if (source[rawEnd] === "\n") rawEnd += 1;

  return {
    raw: source.slice(0, rawEnd),
    title: unescapeMarkdownField(source.slice(titleStart, titleEnd)),
    placement: unescapeMarkdownField(source.slice(placementStart, placementEnd)),
    description: unescapeMarkdownField(source.slice(descriptionStart, lineEnd))
  };
}

function findUnescapedDelimiter(source, start, delimiter) {
  for (let index = start; index <= source.length - delimiter.length; index += 1) {
    if (source[index] === "\\") {
      index += 1;
      continue;
    }
    if (source.startsWith(delimiter, index)) return index;
  }
  return -1;
}

function escapeMarkdownField(value) {
  return String(value)
    .replaceAll("\\", "\\\\")
    .replaceAll("]", "\\]")
    .replaceAll("：", "\\：")
    .replaceAll("\r", "\\r")
    .replaceAll("\n", "\\n");
}

function unescapeMarkdownField(value) {
  let result = "";
  for (let index = 0; index < value.length; index += 1) {
    if (value[index] !== "\\" || index + 1 >= value.length) {
      result += value[index];
      continue;
    }
    const escaped = value[index + 1];
    if (escaped === "n") result += "\n";
    else if (escaped === "r") result += "\r";
    else if (["\\", "]", "："].includes(escaped)) result += escaped;
    else result += `\\${escaped}`;
    index += 1;
  }
  return result;
}
